module.exports = "images/doc-day-add.a1d40a7ccfbeee77ecee5f62c0e8e410.png";